
import { Box, CircularProgress, Avatar, BoxProps } from "@mui/material"

import { CircularProgressStyle } from "../styles/CircularProgress"

export const CircularProgressIndicator = ( props: BoxProps ) => {

    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', ...props }}>
                        
            <CircularProgress size={90} sx={{ color: 'white' }} />
              
            <Box sx={ CircularProgressStyle } >
                
                <Avatar 
                    sx={{ width: 45, height: 45 }}
                    src={ process.env.PUBLIC_URL + '/assets/circular-progress.png'}
                    alt='logo_saji'
                />
                
            </Box>
              
        </Box>
    )
}
